<template>
  <div>
    <v-dialog width="500" v-model="generalActionModal" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-plus</v-icon>
              <span class="modal-title-text mr-2">افزودن اقدام درمانی</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="mt-2">
              <v-combobox label="اقدام درمانی" dense outlined multiple :search-input.sync="serachGeneralAction"
                :items="allGeneralActions" item-text="title" item-value="title" clearable
                clear-icon="mdi-close-circle-outline" prepend-inner-icon="mdi-file-document mdi-18px"
                v-model="selectedGeneralActions"></v-combobox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="addGeneralAction()" dark rounded class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelAddGeneralAction()"
            class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="500" v-model="drugModal" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-plus</v-icon>
              <span class="modal-title-text mr-2">افزودن دارو</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="mt-3">
              <v-autocomplete :items="allDrugGroupsForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                item-text="title" item-value="id" label="گروه دارویی*" clearable clear-icon="mdi-close-circle-outline"
                v-model="selectedDrugGroup" return-object @change="drugGroupChange()" autocomplete="off"
                prepend-inner-icon="mdi-medication mdi-18px"></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-autocomplete :items="allDrugsForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                item-text="title" item-value="id" label="دارو*" return-object clearable
                clear-icon="mdi-close-circle-outline" v-model="selectedDrug" @change="drugChange()" autocomplete="off"
                prepend-inner-icon="mdi-medication mdi-18px"></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-autocomplete :items="allMyDrugOrderType" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                item-text="title" item-value="id" label="نحوه تجویز*" return-object clearable
                clear-icon="mdi-close-circle-outline" v-model="selectedDrugOrderType" autocomplete="off"
                prepend-inner-icon="mdi-medication mdi-18px"></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-text-field type="text" v-model="drugCount" dense outlined
                v-on:keyup.enter="showConfirmDialogFunction()" label="تعداد*" @keypress="isNumberWithDot($event)"
                clearable clear-icon="mdi-close-circle-outline" class="input-label"
                prepend-inner-icon="mdi-text-box mdi-18px"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-autocomplete :items="drugStandByItems" no-data-text="اطلاعاتی وجود ندارد" dense outlined return-object
                item-text="title" item-value="id" label="دستور استفاده*" clearable clear-icon="mdi-close-circle-outline"
                v-model="selectedIsStandBy" autocomplete="off"
                prepend-inner-icon="mdi-medication mdi-18px"></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="addDoctorDrug()" dark rounded class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelAddDoctorDrug()" class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card height="90vh" class="edit-mission-main-card">
          <v-row no-gutters>
            <v-col cols="12" class="modal-header pt-2">
              <v-row no-gutters>
                <v-col cols="1" class="flex items-center justify-start pr-2">
                  <span class="phone-code">
                    کد
                    {{ missionInfo.phone && missionInfo.phone.code ? missionInfo.phone.code : '-' }}
                  </span>
                </v-col>
                <!-- <v-spacer></v-spacer> -->
                <v-col cols="10" class="">
                  <v-tabs center-active centered color="lightColor" v-model="doctorOrderTab">
                    <v-tab v-for="(tabTitle, index) in doctorOrderTabs" :key="index" class="normal-letter-spacing">
                      {{ tabTitle }}
                    </v-tab>
                  </v-tabs>
                  <!-- <v-row>
                    <span :class="tab1Class" @click="changeTab('1')"
                      >اطلاعات ماموریت</span
                    >
                    <v-spacer></v-spacer>
                    <span
                      v-if="hasPatiantFlag"
                      :class="tab2Class"
                      @click="changeTab('2')"
                      >شرح حال</span
                    >
                    <v-spacer v-if="hasPatiantFlag"></v-spacer>
                    <span
                      v-if="hasPatiantFlag"
                      :class="tab3Class"
                      @click="changeTab('3')"
                      >سوابق دارویی و پزشکی و ECG</span
                    >
                    <v-spacer v-if="hasPatiantFlag"></v-spacer>
                    <span
                      v-if="hasPatiantFlag"
                      :class="tab4Class"
                      @click="changeTab('4')"
                      >معاینات</span
                    >
                    <v-spacer v-if="hasPatiantFlag"></v-spacer>
                    <span
                      v-if="hasPatiantFlag"
                      :class="tab5Class"
                      @click="changeTab('5')"
                      >علائم و اقدامات</span
                    >
                    <v-spacer v-if="hasPatiantFlag"></v-spacer>
                    <span :class="tab6Class" @click="changeTab('6')"
                      >توضیحات</span
                    >
                    <v-spacer></v-spacer>
                    <span :class="tab7Class" @click="changeTab('7')"
                      >موقعیت آمبولانس</span
                    >
                  </v-row> -->
                </v-col>
                <!-- <v-spacer></v-spacer> -->
                <v-col cols="1" class="text-left flex items-center justify-end pl-2">
                  <h4 class="time-passed">{{ showPassedTime }}</h4>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters class="dynamic-part">
            <v-col cols="8">
              <!-- in patinet-mode -->
              <v-tabs-items v-if="hasPatiantFlag" v-model="doctorOrderTab">
                <v-tab-item>
                  <mission-information v-bind="transformedInformation" :mission-phone-id="missionPhoneId"
                    @onChangePatient="onChangePatientId" @onChangeHospital="sendMissionToHospitalFunction" />
                </v-tab-item>
                <v-tab-item>
                  <situation-explaination v-bind="transformedInformation?.patientSituationExplaination" />
                </v-tab-item>
                <v-tab-item>
                  <drug-history v-bind="transformedInformation.patientDrugsHistories" />
                </v-tab-item>
                <v-tab-item>
                  <Examinations v-bind="transformedInformation.bodyExamination" />
                </v-tab-item>
                <v-tab-item>
                  <full-body-examination v-bind="transformedInformation.fullBodyExamination" />
                </v-tab-item>
                <v-tab-item>
                  <signs-and-actions v-bind="transformedInformation.patientSignsAndActionsInformation" />
                </v-tab-item>
                <v-tab-item>
                  <phone-triage :mission-id="missionId" />
                </v-tab-item>
                <v-tab-item>
                  <ambulance-position v-if="doctorOrderTab === 7" :mission-id="missionId" :phone-id="phoneId"
                    :mission-phone-id="missionPhoneId" />
                </v-tab-item>
                <v-tab-item>
                  <Description :mission-id="missionId" :mission-phone-id="missionPhoneId" />
                </v-tab-item>
              </v-tabs-items>
              <!-- in none-patinet-mode -->
              <v-tabs-items v-else v-model="doctorOrderTab">
                <v-tab-item>
                  <mission-information v-bind="transformedInformation" :mission-phone-id="missionPhoneId"
                    @onChangePatient="onChangePatientId" @onChangeHospital="sendMissionToHospitalFunction" />
                </v-tab-item>
                <v-tab-item>
                  <phone-triage :mission-id="missionId" />
                </v-tab-item>
                <v-tab-item>
                  <ambulance-position v-if="doctorOrderTab === 2" :mission-id="missionId" :phone-id="phoneId"
                    :mission-phone-id="missionPhoneId" />
                </v-tab-item>
                <v-tab-item>
                  <Description :mission-id="missionId" :mission-phone-id="missionPhoneId" />
                </v-tab-item>
              </v-tabs-items>
            </v-col>
            <v-col cols="4" class="sidebar-action-container pa-3">
              <sidebar-action :patient-doctor-orders="patientDoctorOrders"
                :patient-doctor-actions="patientDoctorActions" :selected-chief-complaint="selectedChiefComplaint"
                :note-text="noteText" :selected-result="selectedResult" @showDrugModal="showDrugModal"
                @removeItemFromDrugs="removeItemFromDrugs" @showGeneralActionModal="showGeneralActionModal"
                @removeItemFromGeneralAction="removeItemFromGeneralAction" @updateChiefComplaint="updateChiefComplaint"
                @updateNoteText="updateNoteText" @updateSelectedResult="updateSelectedResult"
                @saveResult="addPatientDoctorDetailFunction" @closeModal="closeModal" />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import Vue from 'vue';
import { latLng } from 'leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import AlertComponent from '@/components/AlertComponent.vue';
import missionInformation from '../../components/Doctor/missionIonDetail/misssionInformation/index.vue';
import SituationExplaination from '@/components/Doctor/missionIonDetail/situationExplaination.vue';
import DrugHistory from '@/components/Doctor/missionIonDetail/drugHistory.vue';
import Examinations from '@/components/Doctor/missionIonDetail/examinations.vue';
import FullBodyExamination from '@/components/Doctor/missionIonDetail/fullBodyExamination.vue';
import SignsAndActions from '@/components/Doctor/missionIonDetail/signsAndActions.vue';
import PhoneTriage from '@/components/Doctor/missionIonDetail/phoneTriage.vue';
import AmbulancePosition from '@/components/Doctor/missionIonDetail/ambulancePosition.vue';
import Description from '@/components/Doctor/missionIonDetail/description.vue';
import SidebarAction from '@/components/Doctor/action.sidebar.vue';
// -----------------------------------------
import DoctorOrderHelper from '@/Helpers/Doctor/DoctorOrderHelper.js';
import SharedHelper from '@/Helpers/Shared.js';
import snackBar from '@/Mixins/snackBar.js';
import MissionPhoneMixin from '../../Mixins/Mission/MissionPhonesMixin';
import MissionNoteMixin from '@/Mixins/Mission/MissionNoteMixin.js';
import PatientMixin from '@/Mixins/Doctor/PatientMixin.js';
import MissionTransformMixin from '@/Mixins/Mission/mission.transform';
import MissionAddressLogMixin from '@/Mixins/Mission/MissionAddressLogMixin';
import PhoneOnlineLocationMixin from '@/Mixins/BaseInformation/PhoneOnlineLocationMixin';
import SharedMixin from '@/Mixins/Shared.js';
import DrugGroupMixin from '@/Mixins/BaseInformation/DrugGroupMixin';
import DrugMixin from '@/Mixins/BaseInformation/DrugMixin';
import GeneralActionMixin from '@/Mixins/BaseInformation/GeneralActionMixin.js';
import PatientDoctorDetailMixin from '@/Mixins/Doctor/PatientDoctorDetailMixin.js';
import HospitalMixin from '@/Mixins/BaseInformation/HospitalMixin.js';

export default {
  components: {
    AlertComponent,
    missionInformation,
    SituationExplaination,
    DrugHistory,
    Examinations,
    FullBodyExamination,
    SignsAndActions,
    PhoneTriage,
    AmbulancePosition,
    Description,
    SidebarAction,
  },
  mixins: [
    DoctorOrderHelper,
    MissionPhoneMixin,
    PatientMixin,
    snackBar,
    MissionNoteMixin,
    MissionAddressLogMixin,
    PhoneOnlineLocationMixin,
    SharedMixin,
    DrugGroupMixin,
    DrugMixin,
    GeneralActionMixin,
    PatientDoctorDetailMixin,
    SharedHelper,
    HospitalMixin,
    MissionTransformMixin,
  ],
  props: {
    missionPhoneId: {
      type: Number,
      require: true,
      default: null,
    },
    missionId: {
      type: Number,
      require: true,
      default: null,
    },
    phoneId: {
      type: Number,
      require: true,
      default: null,
    },
  },
  created() {
    this.$root.$refs.DoctorOrder = this;
    this.toggleTimer();
  },
  mounted() {
    let currentDate = Vue.moment().format('YYYY-MM-DDTHH:mm:ss');
    this.startDate = currentDate;
    this.mounteLoding();
  },
  data() {
    return {
      zoom: 12,
      center: latLng(30.2839, 57.0834),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; Asemantech',
      withPopup: latLng(30.2839, 57.0834),
      withTooltip: latLng(30.2839, 57.0834),
      currentZoom: 12,
      currentCenter: latLng(30.2839, 57.0834),
      patientId: null,
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        scrollWheelZoom: true,
      },
      dragging: false,
      icon: this.getIcon,
    };
  },
  methods: {
    mounte: function () {
      L.Icon.Default.mergeOptions({
        iconRetinaUrl: require('@/assets/images/marker-icon-2x.png'),
        iconUrl: require('@/assets/images/marker-icon.png'),
        shadowUrl: require('@/assets/images/marker-shadow.png'),
      });
      clearInterval(this.mapSingleMovingIconInterval);
      this.getMissionPhoneByDoctorFunction(this.missionPhoneId);
      this.getAllGeneralActions();
      this.getListOfDrugGroupsForOther();
    },

    onChangePatientId: function (id) {
      this.getPatientFunction(id);
    },
  },
};
</script>
<style scoped lang="scss">
.edit-mission-main-card {
  display: flex;
  flex-direction: column;

  .bottom-part {
    flex: 1;
  }
}

.modal-title-text-menu {
  cursor: pointer;
}

.dynamic-part {
  height: calc(90vh - 67px) !important;
  overflow-y: auto !important;
  overflow-x: hidden;
}

.sidebar-action-container {
  background-color: #f6f6f6;
}

.detail-card {
  border-right: 1px solid var(--dark-color) !important;
  border-left: 1px solid var(--dark-color) !important;
  border-radius: 12px !important;
  background: var(--background-color) !important;
}

.inside-detail-card {
  height: 6.4vh !important;
  background: white !important;
  margin-top: 0.3vh !important;
  border-radius: 12px !important;
}

.patient-list-card {
  border: 1px solid var(--dark-color) !important;
  border-radius: 12px !important;
  overflow-y: auto;
  overflow-x: hidden;
}

.inside-detail-card-data {
  margin-top: 1.5vh !important;
}

.inside-detail-card-data-title {
  font-size: 13px;
  font-weight: 600;
}

.inside-detail-card-data-content {
  font-size: 12px;
  margin-top: 2px !important;
}

.selected-patiant {
  border: 1px solid var(--dark-color) !important;
  border-radius: 8px !important;
  background: var(--background-color) !important;
}

.not-selected-patiant {
  background: var(--background-color) !important;
}

.doctor-tab-3-inside-card {
  background: var(--background-color) !important;
  overflow-y: auto;
  overflow-x: hidden;
}

.human {
  position: relative;
  height: 60vh !important;
  overflow-y: auto !important;
  overflow-x: hidden;
  margin-top: -10vh !important;
}

.human2 {
  position: relative;
  height: 60vh !important;
  overflow-y: auto !important;
  overflow-x: hidden;
  margin-top: -10vh !important;
  margin-left: -20vh !important;
  direction: ltr !important;
}

.note-box {
  border: 1px solid #909090 !important;
  border-radius: 12px !important;
}

.not-box-title {
  position: absolute;
  background: white;
  padding-right: 20px !important;
  margin-top: -1.4vh !important;
  margin-right: 45px !important;
}

.note-box-input {
  margin-top: 2.5vh !important;
}

.note-component-space {
  height: 30vh !important;
  overflow-y: auto !important;
  overflow-x: hidden;
}

.patient-main-info {
  font-size: 13px;
  font-weight: 600;
}

.patient-main-info-value {
  font-size: 12px;
  font-weight: 500;
}

.inside-tab-items-back {
  background: var(--background-color) !important;
  border-radius: 5px !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.active-tab {
  background: var(--background-color) !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
  padding-top: 3px !important;
  padding-bottom: 3px !important;
  border-radius: 4px !important;
  font-size: 13px;
  font-weight: 600;
}

.main-action-card {
  background: var(--background-color) !important;
  overflow-y: auto;
  overflow-x: hidden;
}

.action-part-inside-card {
  border: 1px solid var(--dark-color) !important;
  border-radius: 8px !important;
  overflow-y: auto;
  overflow-x: hidden;
}

.plain-action-btn {
  background: white !important;
  letter-spacing: normal !important;
}

.drug-order-subtitle {
  color: white;
  font-size: 11px;
}

.drug-order-subtitle2 {
  color: white;
  font-size: 10px;
}

.drug-order-title {
  color: white;
  font-size: 13px;
}

.drug-inside-card {
  background: var(--dark-color) !important;
}

.patient-vital-signs-inside-card {
  border: 1px solid var(--dark-color) !important;
  border-radius: 10px !important;
}

.stomach-detail {
  height: 30vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.stoomak-detail-text {
  font-size: 15px;
  font-weight: 600;
  padding-top: 7px !important;
  padding-bottom: 7px !important;
}

.stoomak-detail-text2 {
  font-size: 13px;
  font-weight: 500;
}

.stoomak-detail-part {
  background: white !important;
}

.tchnician-report-note-card {
  background: var(--background-color) !important;
  height: 25vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.time-passed {
  margin-top: 1px !important;
  color: var(--dark-color) !important;
  margin-right: 5px !important;
}

.patient-accompanying-symptoms-space {
  height: 25vh !important;
  overflow-y: auto;
  overflow-x: hidden;
  background: var(--background-color) !important;
}

.patient-accompanying-symptoms {
  background: white !important;
}

.patient-accompanying-symptoms-card {
  background: transparent !important;
}

.patient-accompanying-symptoms-title {
  color: #000000 !important;
  font-size: 13px;
  font-weight: 600;
}

.patient-accompanying-symptoms-inside-title {
  color: #000000 !important;
  font-size: 12px;
  font-weight: 600;
}

.patient-accompanying-symptoms-inside-value {
  color: #000000 !important;
  font-size: 12px;
  font-weight: 500;
}
</style>
